import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class ModelDetailNewsValueObject extends ValueObject {
  /**
   * @param {Array<NewsValueObject>} deps.news
   * @param {Array<NewsValueObject>} deps.videos
   * @param {Array<NewsValueObject>} deps.testDriveVideos
   */

  constructor({news, videos, videopruebas}) {
    super({news, videos, videopruebas})
    this._news = news?.items.slice(0, 3)
  }

  toJSON() {
    return {
      news: {
        count: this._news.length,
        items: this._news
      },
      videos: this._videos,
      testDriveVideos: this._videopruebas
    }
  }
}
